import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "ontos-code" }
const _hoisted_3 = {
  key: 1,
  class: "property-zones"
}
const _hoisted_4 = { class: "property-zone-header" }
const _hoisted_5 = { class: "property-zone-title" }
const _hoisted_6 = {
  key: 1,
  class: "text-body-2 text-medium-emphasis"
}
const _hoisted_7 = { key: 2 }
const _hoisted_8 = {
  key: 1,
  class: "text-body-2 text-grey"
}
const _hoisted_9 = { class: "ontos-code" }
const _hoisted_10 = { key: 3 }
const _hoisted_11 = {
  key: 0,
  class: "access-formula ontos-code"
}
const _hoisted_12 = {
  key: 1,
  class: "text-medium-emphasis"
}
const _hoisted_13 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_header_action = _resolveComponent("ontos-header-action")!
  const _component_ontos_page_header = _resolveComponent("ontos-page-header")!
  const _component_ontos_view_info = _resolveComponent("ontos-view-info")!
  const _component_ontos_info_row = _resolveComponent("ontos-info-row")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_ontos_property_row = _resolveComponent("ontos-property-row")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_ontos_state_list = _resolveComponent("ontos-state-list")!
  const _component_ontos_tabbed_section = _resolveComponent("ontos-tabbed-section")!
  const _component_ontos_ask_dialog = _resolveComponent("ontos-ask-dialog")!
  const _component_ontos_property_dialog = _resolveComponent("ontos-property-dialog")!
  const _component_ontos_class_dialog = _resolveComponent("ontos-class-dialog")!
  const _component_ontos_access_dialog = _resolveComponent("ontos-access-dialog")!
  const _component_ontos_workflow_dialog = _resolveComponent("ontos-workflow-dialog")!
  const _component_ontos_base = _resolveComponent("ontos-base")!

  return (_openBlock(), _createBlock(_component_ontos_base, _mergeProps(_ctx.baseProps, { ref: "base" }), {
    default: _withCtx(() => [
      (_ctx.loaded && _ctx.idea)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_ontos_page_header, _normalizeProps(_guardReactiveProps(_ctx.heading)), _createSlots({
              actions: _withCtx(() => [
                (_ctx.can('designer'))
                  ? (_openBlock(), _createBlock(_component_ontos_header_action, {
                      key: 0,
                      icon: "mdi-delete",
                      label: _ctx.$tt('delete'),
                      color: "error",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.deleteClass()))
                    }, null, 8, ["label"]))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, [
              (_ctx.$slots.controls)
                ? {
                    name: "controls",
                    fn: _withCtx(() => [
                      _renderSlot(_ctx.$slots, "controls", {}, undefined, true)
                    ]),
                    key: "0"
                  }
                : undefined
            ]), 1040),
            _createVNode(_component_ontos_tabbed_section, {
              tabs: _ctx.tabs,
              opens: _ctx.tabOpens,
              routed: !_ctx.ideaAliasProp
            }, {
              controls: _withCtx(({tab}) => [
                (tab === 'info' && _ctx.can('designer'))
                  ? (_openBlock(), _createBlock(_component_ontos_header_action, {
                      key: 0,
                      icon: "mdi-pencil",
                      color: "primary",
                      label: _ctx.$tt('edit'),
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.classOnEdit = true))
                    }, null, 8, ["label"]))
                  : (tab === 'properties' && _ctx.can('designer'))
                    ? (_openBlock(), _createBlock(_component_ontos_header_action, {
                        key: 1,
                        icon: "mdi-plus",
                        color: "primary",
                        label: _ctx.$tt('property-new'),
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openCreate()))
                      }, null, 8, ["label"]))
                    : (tab === 'workflow' && _ctx.can('designer'))
                      ? (_openBlock(), _createBlock(_component_ontos_header_action, {
                          key: 2,
                          icon: "mdi-plus",
                          color: "primary",
                          label: _ctx.$tt('workflow-create-short'),
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openWorkflowCreate()))
                        }, null, 8, ["label"]))
                      : (tab === 'access' && _ctx.can('designer'))
                        ? (_openBlock(), _createBlock(_component_ontos_header_action, {
                            key: 3,
                            icon: "mdi-pencil",
                            color: "primary",
                            label: _ctx.$tt('access.edit'),
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.accessOnEdit = true))
                          }, null, 8, ["label"]))
                        : _createCommentVNode("", true)
              ]),
              default: _withCtx(({tab}) => [
                (tab === 'info')
                  ? (_openBlock(), _createBlock(_component_ontos_info_row, { key: 0 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ontos_view_info, {
                          title: _ctx.$tt('collection-name-singular')
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.idea.name), 1)
                          ]),
                          _: 1
                        }, 8, ["title"]),
                        _createVNode(_component_ontos_view_info, {
                          title: _ctx.$tt('collection-name-plural')
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.idea.pluralName), 1)
                          ]),
                          _: 1
                        }, 8, ["title"]),
                        _createVNode(_component_ontos_view_info, {
                          title: _ctx.$tt('alias')
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.idea.alias), 1)
                          ]),
                          _: 1
                        }, 8, ["title"])
                      ]),
                      _: 1
                    }))
                  : (tab === 'properties')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.propertyZones, (zone) => {
                          return (_openBlock(), _createElementBlock("section", {
                            key: zone.key,
                            class: _normalizeClass(["property-zone", zone.classes])
                          }, [
                            _createElementVNode("header", _hoisted_4, [
                              (zone.icon)
                                ? (_openBlock(), _createBlock(_component_v_icon, {
                                    key: 0,
                                    size: "small",
                                    color: "primary"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(zone.icon), 1)
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true),
                              _createElementVNode("span", _hoisted_5, _toDisplayString(zone.title), 1),
                              (zone.subtitle)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(zone.subtitle), 1))
                                : _createCommentVNode("", true),
                              (_ctx.can('designer'))
                                ? (_openBlock(), _createBlock(_component_v_btn, {
                                    key: 2,
                                    class: "property-zone-create",
                                    variant: "text",
                                    icon: "",
                                    size: "small",
                                    title: zone.createLabel,
                                    onClick: ($event: any) => (_ctx.openCreate(zone.key === 'identifier'))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_icon, { size: "small" }, {
                                        default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                                          _createTextVNode("mdi-plus", -1)
                                        ]))]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["title", "onClick"]))
                                : _createCommentVNode("", true)
                            ]),
                            (zone.notice)
                              ? (_openBlock(), _createElementBlock("p", {
                                  key: 0,
                                  class: _normalizeClass(["property-zone-notice text-body-2", zone.noticeClass])
                                }, _toDisplayString(zone.notice), 3))
                              : _createCommentVNode("", true),
                            _createVNode(_component_draggable, _mergeProps({
                              modelValue: _ctx.layout[zone.key],
                              "onUpdate:modelValue": ($event: any) => ((_ctx.layout[zone.key]) = $event)
                            }, { ref_for: true }, _ctx.propertyDrag, {
                              "data-zone": zone.key,
                              class: "property-list",
                              onStart: ($event: any) => (_ctx.onDragStart(zone.key, $event)),
                              onEnd: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onDrop($event)))
                            }), {
                              item: _withCtx(({element: property}) => [
                                _createVNode(_component_ontos_property_row, {
                                  property: property,
                                  names: _ctx.names,
                                  "can-write": _ctx.can('designer'),
                                  onEdit: _cache[5] || (_cache[5] = ($event: any) => (_ctx.openEdit($event))),
                                  onDelete: _cache[6] || (_cache[6] = ($event: any) => (_ctx.deletingProperty = $event))
                                }, null, 8, ["property", "names", "can-write"])
                              ]),
                              _: 1
                            }, 16, ["modelValue", "onUpdate:modelValue", "data-zone", "onStart"])
                          ], 2))
                        }), 128))
                      ]))
                    : (tab === 'workflow')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          _createVNode(_component_v_row, { "no-gutters": "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, {
                                cols: "12",
                                sm: "6",
                                md: "4"
                              }, {
                                default: _withCtx(() => [
                                  (_ctx.workspace.workflows.length)
                                    ? (_openBlock(), _createBlock(_component_v_select, {
                                        key: 0,
                                        items: _ctx.workspace.workflows,
                                        "item-title": "name",
                                        "item-value": "alias",
                                        "model-value": _ctx.idea.workflow || null,
                                        label: _ctx.$tt('workflow'),
                                        placeholder: _ctx.$tt('workflow-none'),
                                        "persistent-placeholder": "",
                                        clearable: "",
                                        density: "compact",
                                        variant: "outlined",
                                        "onUpdate:modelValue": _ctx.onWorkflowChange
                                      }, _createSlots({ _: 2 }, [
                                        (_ctx.can('designer') && _ctx.idea.workflow && _ctx.workflow)
                                          ? {
                                              name: "append",
                                              fn: _withCtx(() => [
                                                _createVNode(_component_v_btn, {
                                                  icon: "mdi-cog",
                                                  variant: "text",
                                                  size: "small",
                                                  density: "comfortable",
                                                  title: _ctx.$tt('workflow-design-named', {workflow: _ctx.workflow.name}),
                                                  "aria-label": _ctx.$tt('workflow-design-named', {workflow: _ctx.workflow.name}),
                                                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.workflowOnEdit = _ctx.workflow))
                                                }, null, 8, ["title", "aria-label"])
                                              ]),
                                              key: "0"
                                            }
                                          : undefined
                                      ]), 1032, ["items", "model-value", "label", "placeholder", "onUpdate:modelValue"]))
                                    : (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.$tt('workflow-none-in-workspace')), 1))
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          (_ctx.idea.workflow && _ctx.workflow)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createVNode(_component_ontos_info_row, { class: "mb-2" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ontos_view_info, {
                                      title: _ctx.$tt('alias')
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.workflow.alias), 1)
                                      ]),
                                      _: 1
                                    }, 8, ["title"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ontos_state_list, {
                                  states: _ctx.workflow.states,
                                  title: _ctx.$tt('states'),
                                  level: 4,
                                  dense: "",
                                  divider: false
                                }, null, 8, ["states", "title"])
                              ], 64))
                            : _createCommentVNode("", true)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accessKinds, (kind) => {
                            return (_openBlock(), _createBlock(_component_ontos_view_info, {
                              key: kind,
                              title: _ctx.$tt(_ctx.accessLabels[kind])
                            }, {
                              default: _withCtx(() => [
                                (_ctx.idea.access && _ctx.idea.access[kind])
                                  ? (_openBlock(), _createElementBlock("code", _hoisted_11, _toDisplayString(_ctx.idea.access[kind]), 1))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.$tt('access.everyone')), 1))
                              ]),
                              _: 2
                            }, 1032, ["title"]))
                          }), 128))
                        ]))
              ]),
              _: 1
            }, 8, ["tabs", "opens", "routed"]),
            (_ctx.pendingLayout)
              ? (_openBlock(), _createBlock(_component_ontos_ask_dialog, {
                  key: 0,
                  title: _ctx.$tt('identifier-required-title'),
                  message: _ctx.$tt('identifier-required-confirm', {property: _ctx.pendingLayout.entering.name}),
                  actions: _ctx.requiredActions,
                  onPick: _cache[9] || (_cache[9] = ($event: any) => ($event === 'confirm' ? _ctx.saveLayout(_ctx.pendingLayout.layout) : _ctx.cancelLayout())),
                  onClosed: _cache[10] || (_cache[10] = ($event: any) => (_ctx.cancelLayout()))
                }, null, 8, ["title", "message", "actions"]))
              : _createCommentVNode("", true),
            (_ctx.deletingProperty)
              ? (_openBlock(), _createBlock(_component_ontos_ask_dialog, {
                  key: 1,
                  "max-width": "620px",
                  title: _ctx.$tt('delete.title', {collection: _ctx.$tt('property')}),
                  actions: _ctx.deleteActions(),
                  onPick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.onDeletePicked($event))),
                  onClosed: _cache[12] || (_cache[12] = ($event: any) => (_ctx.deletingProperty = null))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("p", {
                      innerHTML: _ctx.$tt('delete.message', {name: _ctx.deletingProperty.name})
                    }, null, 8, _hoisted_13)
                  ]),
                  _: 1
                }, 8, ["title", "actions"]))
              : _createCommentVNode("", true),
            (_ctx.dialogOpen)
              ? (_openBlock(), _createBlock(_component_ontos_property_dialog, {
                  key: 2,
                  idea: _ctx.idea,
                  workspace: _ctx.workspace,
                  property: _ctx.propertyOnEdit,
                  identifier: _ctx.creatingInIdentifier,
                  saving: _ctx.savingProperty,
                  onSave: _cache[13] || (_cache[13] = ($event: any) => (_ctx.saveDialogProperty($event))),
                  onClosed: _cache[14] || (_cache[14] = ($event: any) => (_ctx.closeDialog()))
                }, null, 8, ["idea", "workspace", "property", "identifier", "saving"]))
              : _createCommentVNode("", true),
            (_ctx.classOnEdit)
              ? (_openBlock(), _createBlock(_component_ontos_class_dialog, {
                  key: 3,
                  ref: "classDialog",
                  idea: _ctx.idea,
                  workspace: _ctx.workspace,
                  saving: _ctx.savingClass,
                  onSave: _cache[15] || (_cache[15] = ($event: any) => (_ctx.saveClass($event))),
                  onClosed: _cache[16] || (_cache[16] = ($event: any) => (_ctx.classOnEdit = false))
                }, null, 8, ["idea", "workspace", "saving"]))
              : _createCommentVNode("", true),
            (_ctx.accessOnEdit)
              ? (_openBlock(), _createBlock(_component_ontos_access_dialog, {
                  key: 4,
                  idea: _ctx.idea,
                  workspace: _ctx.workspace,
                  saving: _ctx.savingAccess,
                  onSave: _cache[17] || (_cache[17] = ($event: any) => (_ctx.saveAccess($event))),
                  onClosed: _cache[18] || (_cache[18] = ($event: any) => (_ctx.accessOnEdit = false))
                }, null, 8, ["idea", "workspace", "saving"]))
              : _createCommentVNode("", true),
            (_ctx.workflowOnEdit)
              ? (_openBlock(), _createBlock(_component_ontos_workflow_dialog, {
                  key: 5,
                  workflow: _ctx.workflowOnEdit === true ? undefined : _ctx.workflowOnEdit,
                  workspace: _ctx.workspace,
                  saving: _ctx.savingWorkflow,
                  onCreate: _cache[19] || (_cache[19] = ($event: any) => (_ctx.createWorkflowAndUse($event))),
                  onSave: _cache[20] || (_cache[20] = ($event: any) => (_ctx.saveWorkflow($event))),
                  onClosed: _cache[21] || (_cache[21] = ($event: any) => (_ctx.workflowOnEdit = false))
                }, null, 8, ["workflow", "workspace", "saving"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }, 16))
}